import LegalInformations from "@Front/Components/Layouts/Legal/LegalInformations";

export default function Route(): React.JSX.Element {
	return <LegalInformations />;
}
